import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

// Column
import { RegistrationCancellationColumns } from '../../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries } from '../../../appconfig/Settings';

import { ApplicationTab } from '../applicationTab';
import { OtherApplicationTab } from './OtherApplicationTab';
import moment from 'moment';
import { getAllDetails, postAllData } from '../../../service/ProductService';
import { REGISTRATION_CANCELLATION_LIST, GETHOLDDATA, HOLDUNHOLDAPPLICATION } from '../../../config/ApiConstant';
import { ConvertGMTIST } from '../../../appconfig/AppHelper';
import { regCancelValidate } from '../../../config/Validate';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const RegistrationCancellation = () => {
    document.title = 'Registration Cancellation | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);
    const [searchVal, setSearchVal] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('regcancel_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    // Navigate
    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [applicationsList, setApplicationsList] = useState<any>([]);
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });
    const [addUpdateRegCancelModel, setAddUpdateRegCancelModel] = useState<boolean>(false);
    const [permanentCloseLoader, setPermanentCloseLoader] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<any>(false);
    const [regCancelData, setRegCancelData] = useState<any>({});
    const [showDetailsLoader, setShowDetailsLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});
    const [holdBtn, setHoldBtn] = useState<boolean>(false);
    const [unHoldBtn, setUnHoldBtn] = useState<boolean>(false);
    const [holdBtnLoader, setHoldBtnLoader] = useState<boolean>(false);
    const [unHoldBtnLoader, setUnHoldBtnLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getAllRegistrationCancellationApplication();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates]);

    // Get all registration cancellation application
    const getAllRegistrationCancellationApplication = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(REGISTRATION_CANCELLATION_LIST + '?start_date=' + startDate + '&end_date=' + endDate + '&search=' + searchVal);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setApplicationsList([]);
                } else {
                    setApplicationsList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setApplicationsList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setApplicationsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-2">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '1', cursor: 'pointer' }}></i>
                </span>

                <Button label="" icon="pi pi-search" className="p-button p-button-rounded" onClick={() => getAllRegistrationCancellationApplication()} />
                <Button label="Permanent Cancelled Registration List" onClick={() => navigate('/app/application/permanent-cancelled-registration')} className="p-button-secondary p-button-outlined ml-2"></Button>
                <Button label="Add Registration Cancellation Data" onClick={() => openAddRegCancelModal()} className="ml-2"></Button>
            </>
        );
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'regcancel_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    //remove serach
    const removeSearch = () => {
        setSearchVal(null);
        setGlobalFilter(null);
        getAllRegistrationCancellationApplication();
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Tepmplate for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button label="Edit" icon="pi pi-pencil" onClick={() => openEditRegCancelModal(rowData)} />
                </div>
            </>
        );
    };

    // Template for RegCDate
    const RegCDateTemplate = (rowData: any, rowIndex: any) => {
        return <>{!window.cn(rowData.RegCDate) ? ConvertGMTIST(rowData.RegCDate) : ''}</>;
    };

    // Template for RegCNote
    const RegCNoteTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <Button tooltip={rowData?.RegCNote} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.RegCNote) ? rowData.RegCNote : ''}</div>
                </Button>
            </>
        );
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';
        setRegCancelData({ ...regCancelData, [name]: val });
    };

    // Open add reg cancel modal
    const openAddRegCancelModal = () => {
        setAddUpdateRegCancelModel(true);
    };

    // Open edit reg cancel modal
    const openEditRegCancelModal = (rowData: any) => {
        const { RegNo, RegCNote, SrNo, StudF, StudL, StudM, PAddress, RegCancle } = rowData;
        const name = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');

        // Check Reg Cancellation and Enable Button
        if (RegCancle === 1) {
            setRegCancelData({
                Name: name,
                FileNo: SrNo,
                RegNo: RegNo,
                Reason: RegCNote,
                SrNo: SrNo,
                Address: PAddress
            });
            setHoldBtn(true);
            setUnHoldBtn(false);
        } else {
            setRegCancelData({
                Name: name,
                FileNo: SrNo,
                RegNo: RegNo,
                Reason: RegCNote,
                SrNo: SrNo,
                Address: PAddress,
                btnTextTitle: 'Update'
            });

            setHoldBtn(false);
            setUnHoldBtn(true);
        }
        setIsEdit(true);
        setAddUpdateRegCancelModel(true);
    };

    // Close add reg cancel modal
    const closeAddRegCancelModal = () => {
        setIsEdit(false);
        setErrors({});
        setRegCancelData({});
        setHoldBtn(false);
        setHoldBtnLoader(false);
        setUnHoldBtn(false);
        setUnHoldBtnLoader(false);
        setPermanentCloseLoader(false);
        setAddUpdateRegCancelModel(false);
    };

    // Show reg cancel details
    const showRegCancelDetails = async () => {
        try {
            setShowDetailsLoader(true);

            const response = await getAllDetails(GETHOLDDATA + '?search=' + regCancelData?.RegNo);
            if (response) {
                const { StudF, StudM, StudL, SrNo, PAddress, RegCancle } = response;
                const name = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');

                if (RegCancle === 1) {
                    setRegCancelData({
                        RegNo: regCancelData?.RegNo,
                        Name: name,
                        FileNo: SrNo,
                        SrNo: SrNo,
                        Address: PAddress
                    });
                    setHoldBtn(true);
                    setUnHoldBtn(false);
                } else if (RegCancle === 0) {
                    setRegCancelData({
                        RegNo: regCancelData?.RegNo,
                        Name: name,
                        FileNo: SrNo,
                        SrNo: SrNo,
                        Address: PAddress
                    });
                    setHoldBtn(false);
                    setUnHoldBtn(true);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'This Application was Permanatly Closed'
                    });
                }
                setShowDetailsLoader(false);
            }
        } catch (error: any) {
            setShowDetailsLoader(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response.data.data
            });
        }
    };

    // On hold unhold submit
    const onHoldUnholdSumbit = async (RegCancle: any) => {
        try {
            const { errors, isError } = regCancelValidate(regCancelData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                if (RegCancle === 1) {
                    setHoldBtnLoader(true);
                } else if (RegCancle === 2) {
                    setPermanentCloseLoader(true);
                } else {
                    setUnHoldBtnLoader(true);
                }

                let formData: any = new FormData();
                formData.append('SrNo', regCancelData?.SrNo);
                formData.append('RegCNote', regCancelData?.Reason);
                formData.append('RegCancle', RegCancle);

                const response = await postAllData(HOLDUNHOLDAPPLICATION, formData);
                if (response) {
                    setIsEdit(false);
                    setErrors({});
                    setRegCancelData({});
                    setHoldBtn(false);
                    setHoldBtnLoader(false);
                    setUnHoldBtn(false);
                    setUnHoldBtnLoader(false);
                    setPermanentCloseLoader(false);
                    setAddUpdateRegCancelModel(false);
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: response?.message
                    });
                    setTimeout(() => {
                        getAllRegistrationCancellationApplication();
                    }, 1500);
                } else {
                    setHoldBtnLoader(false);
                    setUnHoldBtnLoader(false);
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Something went wrong, Please try again.'
                    });
                }
            }
        } catch (error: any) {
            setUnHoldBtnLoader(false);
            setHoldBtnLoader(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response.data.data
            });
        }
    };

    return (
        <>
           <ApplicationTab mainTabLabel="Other Application" />
            <OtherApplicationTab initialTabLabel="Reg Cancel" />
            <Toast ref={toast} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applicationsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={applicationsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Applications Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {RegistrationCancellationColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'RegCDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={RegCDateTemplate} sortable />;
                                        } else if (col.field === 'RegCNote') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={RegCNoteTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RegistrationCancellationColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Reg Cancel Dialog */}
            <Dialog
                visible={addUpdateRegCancelModel}
                className="p-fluid"
                style={{ width: '110vh' }}
                header={isEdit === false ? 'Add Registration Cancellation' : 'Update Registration Cancellation'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <div style={{ float: 'left' }}>
                            <Button label="Permanent Close" className="p-button-danger" onClick={() => onHoldUnholdSumbit(2)} loading={permanentCloseLoader} />
                        </div>
                        <div style={{ float: 'right' }}>
                            <Button label="Un Hold" className="p-button-primary" onClick={() => onHoldUnholdSumbit(0)} loading={unHoldBtnLoader} disabled={unHoldBtn} />
                            <Button label="Hold" className="p-button-primary" onClick={() => onHoldUnholdSumbit(1)} loading={holdBtnLoader} disabled={holdBtn} />
                        </div>
                    </>
                }
                onHide={closeAddRegCancelModal}
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="RegNo">Reg No/File No</label>
                        <div className="input-effect-div">
                            <InputText value={regCancelData?.RegNo} autoComplete="off" id="RegNo" onChange={(e) => onInputChange(e, 'RegNo')} className={errors['RegNo'] && 'p-invalid'} />
                            <small className="p-invalid-txt">{errors['RegNo']}</small>
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-2 mt-4">
                        <Button label="Show" className="p-button-primary p-button-outlined" onClick={() => showRegCancelDetails()} loading={showDetailsLoader} />
                    </div>
                </div>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="Name">Name</label>
                        <div className="input-effect-div">
                            <InputText value={regCancelData?.Name} autoComplete="off" id="Name" disabled />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="FileNo">File No</label>
                        <div className="input-effect-div">
                            <InputText value={regCancelData?.FileNo} autoComplete="off" id="FileNo" disabled />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="Address">Address</label>
                        <div className="input-effect-div">
                            <InputTextarea rows={5} cols={30} value={regCancelData?.Address} autoComplete="off" id="Address" disabled />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="Reason">
                            Reason <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputTextarea rows={5} cols={30} value={regCancelData?.Reason} autoComplete="off" id="Reason" onChange={(e) => onInputChange(e, 'Reason')} className={errors['reason'] && 'p-invalid'} />
                            <small className="p-invalid-txt">{errors['reason']}</small>
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};
